module.exports = __webpack_public_path__ + "static/mpost28.cecd8f09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost28.jpg
// module id = 251
// module chunks = 35783957827783 269829036549620